import * as React from 'react';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {getAxios} from '@deviceinsight/ng-ui-api-client';
import {displayConfirmMessage, displayErrorMessage} from './apiUtils';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

const sendButtonPressedEvent = (asset: Asset, dataPoint: string, elementName: string) => {
	const {urn, id, name} = asset;
	const dataAddress = {
		assetUrn: urn,
		assetId: id,
		dataPoint
	};
	getAxios()
		.post(`/rafi/v1/events/buttonPress/${encodeURIComponent(urn)}`, {
			dataAddress
		})
		.then((res) => {
			displayConfirmMessage(
				<Trans
					i18nKey="ruleengine.action.buttonpress.confirm"
					values={{
						elementName,
						name
					}}>
					<>
						The button press for{' '}
						{{
							elementName
						}}{' '}
						of Asset{' '}
						{{
							name
						}}{' '}
						was sent
					</>
				</Trans>
			);
			return res;
		})
		.catch((e) => displayErrorMessage(e, 'DeviceAction'));
};

export {sendButtonPressedEvent};
